import ReconnectingWebSocket, { OpenEvent, CloseEvent } from 'reconnectingwebsocket';

import { config } from './config/config';

import {
  connectionOpened,
  connectionTerminated
} from './connection/reducer';
import { TickerStore } from './index';
import { TickerType } from './models';

export const buildSocketClient = async (tickerId: string, store: TickerStore, tickerType: TickerType) => {

  const tickerUrl = `${config.wssEndpoint}/${tickerType}/${tickerId}`
  const socketOptions: ReconnectingWebSocket.Options = { reconnectInterval: 3000, maxReconnectAttempts: 100, reconnectDecay: 2, timeoutInterval: 50000 }
  const client = new ReconnectingWebSocket(tickerUrl, undefined, socketOptions)

  client.onopen = (event: OpenEvent) => store.dispatch(connectionOpened(event))
  client.onclose = (event: CloseEvent) => {
    store.dispatch(connectionTerminated())
  }

  return client

}
